import React from 'react';
import { CardLinkView } from '../../../view/LinkView';
import { loadingPlaceholderClassName } from './LazyFallback';
export const LoadingCardLink = ({
  isSelected,
  url,
  placeholder
}) => {
  return /*#__PURE__*/React.createElement(CardLinkView, {
    key: 'lazy-render-key',
    testId: 'lazy-render-placeholder',
    "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
    isSelected: isSelected,
    link: url,
    className: loadingPlaceholderClassName,
    placeholder: placeholder
  });
};